import React from 'react'
import './editPageTop.css'
import xz_logo from './imageSrc/xz_funtionPageLogo.png'
import new_work from './imageSrc/new_work.png'
import save_work from './imageSrc/save_work.png'
import user_center from './imageSrc/user_center.png'

class EditPadTop extends React.Component {
    constructor(props) {
        super(props)
    }

    handleShowSetting = () => {
        this.props.showSettingPage();
    };

    handleSaveFile =() => {
        this.props.saveFile();
    };

    handleNewWork = () => {
        this.props.newWork();
    };

    render() {
        return (
            <div className='divTop'>
                <button onClick={this.handleSaveFile} className='save_button_style saveWork'><img className="newWorkImg" src={save_work}/></button>
                <button onClick={this.handleNewWork} className='save_button_style newWork'><img className="newWorkImg" src={new_work}/></button>
                <img className='logo_style' src={xz_logo}/>
                <div onClick={this.handleShowSetting} className='div_mine_style'>
                <img className="newWorkImg" src={user_center}/>
                </div>
            </div>
        )
    }
}

export default EditPadTop;
